import { NotesTransitOperationInfoRequest } from '../../../../../api/models'

// eslint-disable-next-line import/prefer-default-export
export function toNotesOrFeedbackTransitOperationInfoRequest(
  notes: string,
): NotesTransitOperationInfoRequest {
  return {
    notes,
  }
}
